import AnnotationDataStream from "./AnnotationDataStream";
import MapObjectAnnotation from "../element/MapObjectAnnotation";

export default class FromOMBAnnotationDataStream extends AnnotationDataStream {
    constructor(id, allElements, urlToAssets, mapObjectStatusDataStream, forceAllVisible = false) {
        super(id, forceAllVisible);

        this.annotations = [];
        this.styles = [];

        for (var element of allElements) {
            if (element instanceof MapObjectAnnotation) {
                this.annotations.push(element);

                const style = element.getMapElementStyle(urlToAssets);
                if (style) {
                    this.styles.push(style);
                }
            }
        }

        if (mapObjectStatusDataStream) {
            mapObjectStatusDataStream.observe().subscribe((data) => {
                if (data) {
                    const mapObjectStatusTemplates = data.mapObjectStatusTemplates;
                    const mapObjectStatusList = data.mapObjectStatusList;
    
                    if (mapObjectStatusTemplates && mapObjectStatusList) {
                        for (var annotation of this.annotations) {
                            const mapObjectStatus = this._findMapObjectStatusForAnnotation(annotation.getId(), mapObjectStatusList);
                            if (mapObjectStatus) {
                                const normalStyle = annotation.normalStyle;
                                if (normalStyle) {
                                    const mapObjectStatusTemplate = this._findMapObjectStatusTemplate(mapObjectStatus.mapObjectStatusTemplateId, mapObjectStatusTemplates);
                                    if (mapObjectStatusTemplate) {
                                        const statusVisibleStyle = JSON.parse(JSON.stringify(normalStyle));
                                        statusVisibleStyle.strokeColor = mapObjectStatusTemplate.color;
                                        statusVisibleStyle.label = mapObjectStatusTemplate.title;
                                        annotation.statusVisibleStyle = statusVisibleStyle;
                                    }
                                }
                            } else {
                                annotation.statusVisibleStyle = null;
                            }
                        }
                    }
    
                    this.initialize(this.annotations);
                }
            });
        }
    }

    toJSON() {
        const json = super.toJSON();
        json.type = "annotation";
        json.elements = [];

        var topLatitude = -90.0;
        var leftLongitude = 180.0;
        var bottomLatitude = 90.0;
        var rightLongitude = -180.0;

        for (var element of this.annotations) {
            if (!element.getName().endsWith("- Extra") && element.getId() != "2hpl" && element.getId() != "amfc" && element.getId() != "jlkg" && element.getName() != "Shuttle"
                && element.getId() != "j3hx" && element.getId() != "jbc7") {
                var elementLocation = null;
                if (element.mapObject.placeInformation && element.mapObject.placeInformation.location) {
                    elementLocation = element.mapObject.placeInformation.location;
                } else {
                    elementLocation = element.getLocation();
                }
    
                if (element.id.length < 10) {
                    json.elements.push({
                        id: element.getId(),
                        name: element.getName(),
                        location: elementLocation
                    });
        
                    if (elementLocation) {
                        topLatitude = Math.max(topLatitude, elementLocation.latitude);
                        leftLongitude = Math.min(leftLongitude, elementLocation.longitude);
                        bottomLatitude = Math.min(bottomLatitude, elementLocation.latitude);
                        rightLongitude = Math.max(rightLongitude, elementLocation.longitude);
                    }
                }
            }
        }

        json.topLeftBound = { latitude: topLatitude, longitude: leftLongitude };
        json.bottomRightBound = { latitude: bottomLatitude, longitude: rightLongitude };

        return json;
    }

    _findMapObjectStatusForAnnotation(annotationId, mapObjectStatusList) {
        for (var mapObjectStatus of mapObjectStatusList) {
            if (mapObjectStatus.mapObjectId === annotationId) {
                return mapObjectStatus;
            }
        }

        return null;
    }

    _findMapObjectStatusTemplate(templateId, mapObjectStatusTemplates) {
        for (var mapObjectStatusTemplate of mapObjectStatusTemplates) {
            if (mapObjectStatusTemplate.id === templateId) {
                return mapObjectStatusTemplate;
            }
        }
        return null;
    }
}